import { AbstractManager } from "./AbstractManager.js";
import {
  isDev,
  isArray,
  isDefined,
  getAncestorWhereUntil,
  endsWith,
  startsWith
} from "../../utils/index.js";
const NORMALIZE_REF_NAME_REGEX = /\[\]$/;
const NAMESPACED_REF_REGEX = /^(.*\.)/;
const normalizedRefNamesCache = /* @__PURE__ */ new Map();
function normalizeRefName(name) {
  if (normalizedRefNamesCache.has(name)) {
    return normalizedRefNamesCache.get(name);
  }
  let normalizedName = name;
  if (endsWith(name, "[]")) {
    normalizedName = normalizedName.replace(NORMALIZE_REF_NAME_REGEX, "");
  }
  if (normalizedName.includes(".")) {
    return normalizedName.replace(NAMESPACED_REF_REGEX, "");
  }
  normalizedRefNamesCache.set(name, normalizedName);
  return normalizedName;
}
function refBelongToInstance(ref, rootElement, name) {
  const isPrefixed = startsWith(ref.dataset.ref, name);
  const firstComponentAncestor = getAncestorWhereUntil(
    ref,
    (el) => el && (isPrefixed ? el.dataset.component === name && el : isDefined(el.dataset.component)) && el !== rootElement,
    (el) => el === rootElement
  );
  return firstComponentAncestor === rootElement;
}
function __register(that, refName) {
  const isMultiple = endsWith(refName, "[]");
  const propName = normalizeRefName(refName);
  const { name } = that.__base.$options;
  const refs = Array.from(
    that.__element.querySelectorAll(
      `[data-ref="${refName}"],[data-ref="${name}.${refName}"]`
    )
  ).filter((ref) => refBelongToInstance(ref, that.__element, name));
  if (isDev && !isMultiple && refs.length > 1) {
    console.warn(
      // @ts-ignore
      `[${that.__base.$options.name}]`,
      `The "${refName}" ref has been found multiple times.`,
      "Did you forgot to add the `[]` suffix to its name?"
    );
  }
  if (!isMultiple && refs.length <= 1 && !isDefined(refs[0])) {
    if (isDev) {
      console.warn(
        // @ts-ignore
        `[${that.__base.$options.name}]`,
        `The "${refName}" ref is missing.`,
        `Is there an \`[data-ref="${refName}"]\` element in the component's scope?`
      );
    }
    return;
  }
  that.__eventsManager.bindRef(refName, refs);
  Object.defineProperty(that, propName, {
    // @todo remove usage of non-multiple refs as array
    value: isMultiple || refs.length > 1 ? refs : refs[0],
    enumerable: true,
    configurable: true
  });
}
function __unregister(that, refName) {
  const propName = normalizeRefName(refName);
  const refs = isArray(that[propName]) ? that[propName] : [that[propName]];
  that.__eventsManager.unbindRef(refName, refs);
}
class RefsManager extends AbstractManager {
  /**
   * Get refs configuration.
   */
  get __refs() {
    return this.__config.refs ?? [];
  }
  /**
   * Register all refs.
   */
  registerAll() {
    for (const refName of this.__refs)
      __register(this, refName);
  }
  /**
   * Unregister all refs.
   */
  unregisterAll() {
    for (const refName of this.__refs)
      __unregister(this, refName);
  }
}
export {
  RefsManager,
  normalizeRefName
};
//# sourceMappingURL=RefsManager.js.map
